import { modafinil } from './initial/flow';
import { modafinilFollowup } from './followup/flow';

const ModafinilFlows = {
  modafinil,
  modafinilFollowup
};

export default ModafinilFlows;
